import React from 'react'
import { useTranslation } from "react-i18next";
import { Box, Stack, Typography } from '@mui/material'
import colors from '../theme/colors';

export const HistoricoCuestionarioPerfilEmpresarial = ({ PerfilEmpresarial }) => {

    const { t } = useTranslation();

    // TODO Tomas repasar
    return (

        <Stack
            direction={{xs: 'column', md: 'column', lg: 'row'}}
            sx={{width: '100%', color: colors.textLink}}
        >
            {PerfilEmpresarial?.nif &&
                <Box sx={{ flex: '1 1 0px', textAlign: { xs: 'left', md: 'left', lg: 'center' } }}>
                    <Box component={Typography} variant={'subtitle1'} sx={{ fontWeight: 'bold', textDecoration: 'underline' }}>
                        {t('crearPerfilEmpresarial.cif')}
                    </Box>
                    <Box component={Typography} variant='subtitle2'>
                        {PerfilEmpresarial?.nif}
                    </Box>
                </Box>
            }
            <Box sx={{flex: '1 1 0px', textAlign: {xs: 'left', md: 'left', lg: 'center'}}}>
                <Box component={Typography} variant={'subtitle1'} sx={{ fontWeight: 'bold', textDecoration: 'underline' }}>
                    {t('crearPerfilEmpresarial.nombre')}
                </Box>
                <Box component={Typography} variant='subtitle2'>
                {PerfilEmpresarial?.razon_social}
                </Box>
            </Box>
            {PerfilEmpresarial?.volumenNegocio?.texto &&
                <Box sx={{ flex: '1 1 0px', textAlign: { xs: 'left', md: 'left', lg: 'center' } }}>
                    <Box component={Typography} variant={'subtitle1'} sx={{ fontWeight: 'bold', textDecoration: 'underline' }}>
                        {t('crearPerfilEmpresarial.volumenNegocio')}
                    </Box>
                    <Box component={Typography} variant='subtitle2'>
                        {PerfilEmpresarial?.volumenNegocio?.texto}
                    </Box>
                </Box>
            }
        </Stack >
    )
}
